export default __webpack_public_path__ + "static/lit-56c39847a6da55caefee82e17a338ca0.png";